import React from 'react'
import { usePlan } from '../../hooks/useFeature'
import Alert from '../Alert'
import Button from '../Button'

// Shown where a plan feature decides what a person can do, when the plan could not be read.
const PlanFeatureAlert = (props) => {
  const { plan, error, refresh } = usePlan()
  if (plan || !error) return null

  return (
    <Alert variant="warning" {...props}>
      Não foi possível verificar os recursos do plano. {error}{' '}
      <Button variant="link" onClick={() => refresh()}>Tentar novamente</Button>
    </Alert>
  )
}

export default PlanFeatureAlert
